import { CreateAuthHeaders, FetchGet } from '../utils/dataModel';

class DashboardLicenseApiService {
  
  async getLicenseData() {
    return new Promise((resolve, reject) => {
      const api = `/api/v1/dashboard/license`;
      FetchGet(api, CreateAuthHeaders("session_id"))
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        console.error('Error fetching history data:', error);
        reject(error);
      });
    });
  }
}

const license_service = new DashboardLicenseApiService();
export default license_service;